import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header, Footer, Sidebar } from '@/components/layout'
import { PageLoader } from './PageLoader'

// Main app layout with header and sidebar
export const AppLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

      {/* Mobile sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {/* Main content area */}
      <main className="flex-1 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 w-full">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>

      <Footer />
    </div>
  )
}

export default AppLayout
